import React from 'react';
import AuditLog from '../admin/pages/AuditLog.tsx';

/** Org-admin audit log — same UI as platform admin, scoped to current organization. */
const OrgAuditLogPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <AuditLog mode="org" />
    </div>
  );
};

export default OrgAuditLogPage;
